import React, { createRef, useEffect, useRef, useState } from "react";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomButton from "../../components/CustomButton/custombutton";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import AntFileUpload from "../../components/AntFileUpload/AntFileUpload";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import "./Tire.css";
import Table from "../../components/Table/Table";
import { Box } from "@material-ui/core";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import getToken from "../getToken";
import img_coming_soon from "../../images/icons/coming_soon.png";

const Tire = () => {
  const [showAddTire, setShowAddTire] = useState(false);
  const [showEditTire, setShowEditTire] = useState(false);
  const refTireTable = createRef();
  const refTireListForm = useRef(null);
  const refFormulaSelectList = useRef();
  const [keyword, setKeyword] = useState("");
  const tireId = useRef(0);
  const [tireDetail, setTireDetail] = useState({
    name: "",
    formula: "",
    maxAmount: "",
    minAmount: "",
    benefit: "",
    tierExpire: "",
    files: null,
  });
  const [editBenefitField, setEditBenefitField] = useState(null);
  const [benefitFields, setBenefitFields] = useState([{ id: 1, value: "" }]);

  const clickAddTire = (e) => {
    e.stopPropagation();
    if (showEditTire) {
      setShowEditTire(false);
      setTimeout(() => setShowAddTire(true), 100);
    } else {
      setShowAddTire(true);
    }
    setTireDetail({});
  };
  const clickBtnClose = () => {
    setShowAddTire(false);
    setShowEditTire(false);
    setBenefitFields([{ id: 1, value: "" }]);
    setEditBenefitField(false);
  };
  const clickAddBenefit = () => {
    setBenefitFields((prevFields) => [
      ...prevFields,
      { id: prevFields.length + 1, value: "" },
    ]);
  };

  const removeBenefitField = (idToRemove) => {
    setBenefitFields((prevFields) =>
      prevFields.filter((field) => field.id !== idToRemove)
    );
  };

  const clickDeleteTier = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this item?")) {
      api
        .post(`Admin/DeleteTier?TierId=${rowData.id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Tire deleted successfully!");
                retrieveTireList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  const formula_list = [
    {
      label: "<=",
      value: "<=",
    },
    {
      label: "<",
      value: "<",
    },
    {
      label: ">",
      value: ">",
    },
    {
      label: ">=",
      value: ">=",
    },
  ];

  const AddTireFormValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    formula: Yup.string().required("Please choose the formula."),
    max_amount: Yup.number().required("Please enter the maximum amount."),
    min_amount: Yup.number().required("Please enter the minimum amount."),
    tierExpire: Yup.number().required(
      "Please enter expired year of tier benefit."
    ),
    benefits: Yup.array().of(Yup.string().required("Benefit is required")),
    files: Yup.array().nullable().required("Please choose the images."),
  });

  const [tireList, setTireList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  const [paramTierBenefitList, setParamTierBenefitList] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const retrieveTireList = (value = paramTierBenefitList) => {
    value.keyword = keyword || "";
    if (value.keyword) {
      value.currentPage = 1;
    }
    setTireList({
      isLoading: true,
      ...tireList,
    });

    api
      .post("Admin/GetTierBenefitListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setTireList({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
            } else {
              setTireList({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            alert(error);
          }
        );
      });
  };

  const handleTireSubmit = (values, actions) => {
    const tire = {
      name: values.name,
      minAmount: parseInt(values.min_amount),
      maxAmount: parseInt(values.max_amount),
      formula: values.formula,
      tierExpire: values.tierExpire,
      benefit:
        values.benefit !== null
          ? benefitFields
              .map((field) => values[`benefit_${field.id}`])
              .join(",")
          : "",
      image: values.files[0].url.replace(/^data:(.*,)?/, ""),
    };

    api
      .post("Admin/CreateTierBenefitByAdmin", tire, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert("Tire saved successfully!!");

              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              refFormulaSelectList.current.selectOption("");
              for (let i = 0; i < refTireListForm.current.length - 2; i++) {
                refTireListForm.current[i].value = "";
              }
              actions.resetForm();
              values = {};
              setShowAddTire(false);
              // refresh tire list
              retrieveTireList();
            } else {
              alert(response.data.value.message);
            }
          },
          (error) => {
            console.log(error);
          }
        )
      );
    actions.setSubmitting(false);
  };

  const clickBtnEditTire = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    getTireDetail(id);
  };

  const getTireDetail = (id) => {
    setTireDetail({});
    api
      .get("Admin/GetTierBenefitDetail", { TierId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log("GetTierBenefitDetail" + response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setTireDetail(response.data.value.data);
              setShowEditTire(true);

              const existingBenefits = response.data.value.data.benefit;
              setBenefitFields(
                existingBenefits
                  ? existingBenefits.split(",").map((benefit, index) => {
                      return {
                        id: index + 1,
                        value: benefit.trim(),
                      };
                    })
                  : []
              );
              console.log("existingBenefits:", existingBenefits);

              tireId.current = id;
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editTireSubmit = (values, actions) => {
    const benefit = benefitFields
      .map((field) => {
        return field.value == "" ? values[`benefit_${field.id}`] : field.value;
      })
      .join(", ");

    const tire = {
      id: tireId.current,
      name: values.name,
      minAmount: parseInt(values.min_amount),
      maxAmount: parseInt(values.max_amount),
      formula: values.formula,
      tierExpire: values.tierExpire,
      benefit: benefit,
      image: values.files[0].url.replace(/^data:(.*,)?/, ""),
    };
    api
      .post("Admin/UpdateTierBenefitByAdmin", tire, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert("Tire updated successfully!!");
              setShowEditTire(false);
              actions.resetForm();
              retrieveTireList();
            } else {
              alert(response.data.value.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  useEffect(() => {
    retrieveTireList();
  }, [paramTierBenefitList, keyword]);

  return (
    <>
      {(showAddTire || showEditTire) && (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">Tier</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={{
              name: tireDetail.name ? tireDetail.name : "",
              formula: tireDetail.formula ? tireDetail.formula : "",
              max_amount: tireDetail.maxAmount ? tireDetail.maxAmount : "0",
              min_amount: tireDetail.minAmount ? tireDetail.minAmount : "0",
              tierExpire: tireDetail.tierExpire ? tireDetail.tierExpire : "",
              benefit: tireDetail.benefit ? tireDetail.benefit : "",
              files: tireDetail.image
                ? [
                    {
                      uid: "1",
                      status: "done",
                      url: tireDetail.image,
                    },
                  ]
                : null,
            }}
            validationSchema={AddTireFormValidation}
            validateOnBlur={false}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              if (showEditTire) {
                editTireSubmit(values, actions);
              } else {
                handleTireSubmit(values, actions);
              }
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form
                ref={refTireListForm}
                className="row form-container add-tire-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>

                <div className="col-6 mt-2">
                  <CustomSelect
                    options={formula_list}
                    name="formula"
                    label="Formula"
                    isClearable={false}
                    placeholder="Choose Formula"
                    refSelect={refFormulaSelectList}
                  />
                </div>

                <div className="col-6 mt-2">
                  <CustomInput
                    name="max_amount"
                    type="number"
                    label="Max Point"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="100000"
                  />
                </div>

                <div className="col-6 mt-2">
                  <CustomInput
                    name="min_amount"
                    type="number"
                    label="Min Point"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="0"
                  />
                </div>

                <div className="col-12 mt-2">
                  <CustomInput
                    name="tierExpire"
                    type="number"
                    label="Tier Expire (day)"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>

                <div className="col-6 mt-2">
                  <button
                    type="button"
                    className="benefit-btn"
                    onClick={clickAddBenefit}
                  >
                    <img alt="addimage" src={add} className="addimgIcon" />{" "}
                    {/* Add a space here */}
                    Add Benefit
                  </button>
                </div>

                {benefitFields.map((field) => (
                  <div
                    className="col-12 my-2 d-flex align-items-center"
                    key={field.id}
                  >
                    <div className="flex-grow-1">
                      <div className="benefitInput">
                        <label htmlFor={`benefit_${field.id}`}>
                          {" "}
                          {`Benefit ${field.id}`}{" "}
                        </label>
                        <input
                          type="text"
                          id={`benefit_${field.id}`}
                          className="inputBox mt-2"
                          value={
                            values[`benefit_${field.id}`] ||
                            (editBenefitField === field.id
                              ? ""
                              : tireDetail?.benefit
                                  ?.split(",")
                                  ?.[field.id - 1]?.trim()) ||
                            ""
                          }
                          autoComplete="off"
                          placeholder="Enter Benefit"
                          onChange={(e) => {
                            const modifiedValue = e.target.value;
                            const currentValue =
                              values[`benefit_${field.id}`] || "";
                            if (modifiedValue !== currentValue) {
                              setFieldValue(
                                `benefit_${field.id}`,
                                modifiedValue
                              );
                            } else {
                              setFieldValue(
                                `benefit_${field.id}`,
                                currentValue
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    {editBenefitField !== field.id && (
                      <button
                        type="button"
                        className="btn btnRemove ml-2 mt-4"
                        onClick={() => removeBenefitField(field.id)}
                      >
                        <img src={delete_icon} alt="" className="imgIcon" />
                      </button>
                    )}
                  </div>
                ))}

                <div className="col-12 mt-2">
                  <AntFileUpload
                    label="Image"
                    name="files"
                    addIcon={true}
                    inputText="Drag and drop or browse to choose a file"
                    // fileList={values.files}
                    aspectRatio={9 / 3}
                    // maxSizeInByte={358400}
                    multiiple={false}
                    imageQuality={0.8}
                    accept={".png, .jpg, .jpeg"}
                    onChange={({ fileList: newFileList }) => {
                      if (newFileList.length > 0) {
                        // Only a file upload. if the fileList length is greater than 1, remove index 0;
                        if (newFileList.length > 1) {
                          newFileList.shift();
                        }
                        newFileList = newFileList.map((file) => {
                          return {
                            ...file,
                            status: "done",
                            percent: 100,
                            response: "Success",
                          };
                        });
                        const successFiles = newFileList.filter(
                          (file) => file.status !== "error"
                        );

                        setFieldValue("files", successFiles);
                      } else {
                        setFieldValue("files", null);
                      }
                      console.log(values.files);
                    }}
                    onRemove={(file) => {
                      if (file.url) {
                        setFieldValue("deletedImage", [
                          ...values.deletedImage,
                          file,
                        ]);
                      }
                      if (values.files.length === 1) {
                        setFieldValue("files", null);
                      }
                    }}
                  />
                </div>

                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddTire ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {/* </div>
            </div>
          </div> */}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Tier</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveTireList()}
          />
          {!showAddTire && (
            <CustomButton
              icon={add}
              text="Add Tier Level"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddTire(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container tire_table">
        <Table
          key={tireList.total}
          ref={refTireTable}
          maxBodyHeight={tireList.limit * 70}
          isLoading={tireList.isLoading}
          grouping={tireList.grouping}
          limit={tireList.limit}
          page={tireList.page}
          total={tireList.total}
          data={tireList.data}
          onPageChange={(page) => {
            setParamTierBenefitList({
              ...paramTierBenefitList,
              currentPage: page,
            });
            retrieveTireList(paramTierBenefitList);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (tireList.page - 1) * tireList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.image == null || row.image == "") {
                  row.image = img_coming_soon;
                }
                return (
                  <img
                    src={row.image}
                    alt=""
                    className="d-block imgTire"
                    onError={(e) => (e.target.src = img_coming_soon)}
                  />
                );
              },
              width: "160px",
            },
            {
              title: "Tier",
              render: (row) => {
                if (row.name.length > 40) {
                  return String(row.name).substring(0, 39) + "...";
                }
                return row.name;
              },
              width: "270px",
            },
            {
              title: "Max Value",
              render: (row) => {
                return row.maxAmount.toLocaleString();
              },
              width: "160px",
            },
            {
              title: "Min Value",
              render: (row) => {
                return row.minAmount.toLocaleString();
              },
              width: "250px",
            },
            {
              title: "Tier Expire (day)",
              render: (row) => {
                return row.tierExpire;
              },
              width: "250px",
            },
            {
              title: "Tier Benefit",
              render: (row) => {
                if (row.benefit == null || row.benefit == "") {
                  return "-";
                } else {
                  return String(row.benefit).substring(0, 20) + "...";
                }
              },
              width: "200px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickBtnEditTire(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDeleteTier(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default Tire;
